'use client'

// libraries
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'

export const useStaggerUp = () => {
	
	useGSAP(() => {
		// Find all elements with data-stagger-up attribute
		const staggerContainers = document.querySelectorAll('[data-stagger-up="true"]')
		
		// Set up Intersection Observer
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const container = entry.target
						const children = container.children

						if (children.length > 0) {
							gsap.fromTo(children, 
								{
									opacity: 0,
									y: '10vh'
								}, 
								{
									opacity: 1,
									y: 0,
									duration: 0.6,
									stagger: 0.1
								}
							)
						}

						// Stop observing this container after animation triggers
						observer.unobserve(container)
					}
				})
			},
			{
				threshold: 0.1, // Trigger when 10% of element is visible
				rootMargin: '0px 0px -10% 0px' // Similar to start: '0% 90%'
			}
		)

		// Observe all containers
		staggerContainers.forEach(container => {
			// Set initial state
			if (container.children.length > 0) {
				gsap.set(container.children, {
					opacity: 0,
					y: '10vh'
				})
			}
			observer.observe(container)
		})

		// Cleanup function
		return () => {
			observer.disconnect()
		}
	})
} 